import React, { useContext } from 'react';
const consumerPreferencesContext = React.createContext({});
export function ConsumerPreferencesProvider({ children, preferences, }) {
    return (React.createElement(consumerPreferencesContext.Provider, { value: preferences }, children));
}
export const useConsumerPreferences = () => useContext(consumerPreferencesContext);
//# sourceMappingURL=consumer-preferences.js.map